import React, { ReactNode, useEffect } from "react";
import { SitePage } from "../../types/SitePage";
import TopNav from "../TopNav/TopNav";
import "./AdminPageLayout.scss";

interface AdminPageLayoutProps {
  children: ReactNode;
  title?: string;
}

const AdminPageLayout: React.FC<AdminPageLayoutProps> = ({
  children,
  title,
}) => {
  useEffect(() => {
    if (title) {
      document.title = `${title}, Admin - PoolTonight`;
    }
  }, [title]);

  return (
    <div className="admin-page-layout">
      <TopNav page={SitePage.Admin} />
      <main className="admin-page-main-content">{children}</main>
    </div>
  );
};

export default AdminPageLayout;
